import { Button } from '@/components/ui/button';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SingleDatePicker } from '@/components/common/date-picker/single-date-picker';

const SelfServiceHistoryFilters = ({
  historyDate,
  historyActionType,
  historySummary,
  onDateChange,
  onActionTypeChange,
  onNavigateToPending,
  isLoading = false,
}) => {
  const actionTypeOptions = [
    {
      value: 'sent',
      label: 'Sent',
      count: historySummary?.sent_count || 0,
    },
    {
      value: 'skipped',
      label: 'Skipped',
      count: historySummary?.skipped_count || 0,
    },
    {
      value: 'not_found',
      label: 'Not Found',
      count: historySummary?.not_found_count || 0,
    },
  ];

  const toYmd = (input) => {
    if (typeof input === 'string') return input;
    const year = input.getFullYear();
    const month = String(input.getMonth() + 1).padStart(2, '0');
    const day = String(input.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const ymdToDate = (ymd) => {
    if (ymd instanceof Date) return ymd;
    if (typeof ymd === 'string') {
      const [y, m, d] = ymd.split('-').map((n) => parseInt(n, 10));
      return new Date(y, m - 1, d);
    }
    return new Date();
  };

  const handleDateUpdate = ({ date }) => {
    onDateChange(toYmd(date));
  };

  return (
    <div className='flex flex-col gap-4'>
      {/* Navigation Buttons */}
      <div className='flex items-center gap-2'>
        <Button
          variant='outline'
          size='sm'
          onClick={onNavigateToPending}
          className='text-xs'
        >
          ← Back to Pending
        </Button>
      </div>

      {/* Date Picker */}
      <div className='flex items-center gap-4'>
        <SingleDatePicker
          defaultPreset='today'
          initialDate={ymdToDate(historyDate)}
          onUpdate={handleDateUpdate}
          disabled={isLoading}
        />

        {/* Action Type Filter */}
        <Tabs
          value={historyActionType}
          onValueChange={onActionTypeChange}
          className='w-auto'
          disabled={isLoading}
        >
          <TabsList className='grid w-full grid-cols-3' disabled={isLoading}>
            {actionTypeOptions.map((option) => (
              <TabsTrigger
                key={option.value}
                value={option.value}
                className='text-xs sm:text-sm'
                disabled={isLoading}
              >
                {option.label} ({option.count})
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      </div>
    </div>
  );
};

export default SelfServiceHistoryFilters;
